module.exports = __webpack_public_path__ + "static/media/thierry_kibagabaga4.a5d697dd.jpg";